import * as React from 'react';
import moment, { Moment } from 'moment-timezone';
import { ISODateTime } from '../../types/date';
import './timeRange.module.scss';

type DateProps = {
  date: ISODateTime | Moment;
};
export const DetailedDate2 = ({ date }: DateProps) => <span>{moment(date).format('YYYY/MM/DD')}</span>;

export const DetailedDateRange = ({ fromDate, toDate }) => (
  <span>
    {moment(fromDate).format('YYYY年M月D日')}〜{toDate && moment(toDate).format('YYYY年M月D日')}
  </span>
);

export const DetailedPeriod = ({ startsAt, expiresAt }) => (
  <span>
    {startsAt && moment(startsAt).format('YYYY年M月D日')}〜
    {expiresAt && moment(expiresAt).subtract(1, 'd').format('YYYY年M月D日23:59')}
  </span>
);
